import { render, staticRenderFns } from "./ReviewInteresting.vue?vue&type=template&id=66a00a68&scoped=true&"
import script from "./ReviewInteresting.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ReviewInteresting.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ReviewInteresting.vue?vue&type=style&index=0&id=66a00a68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a00a68",
  null
  
)

export default component.exports